import React, {type FC, useMemo} from 'react';

import {trackBreadcrumbClicked} from '../../../../util/navigation';
import * as links from '../../../../util/urls';
import Breadcrumbs, {type BreadcrumbPart} from '../../../Breadcrumbs';

export type NavBreadcrumbsPublishedReportProps = {
  entityName: string;
  reportID: string;
  reportName: string;
};

export function useNavBreadcrumbsPublishedReportParts({
  entityName,
  reportID,
  reportName,
}: NavBreadcrumbsPublishedReportProps): BreadcrumbPart[] {
  const parts: BreadcrumbPart[] = useMemo(
    () => [
      {
        label: entityName,
        to: `/${entityName}`,
        onClick: () => trackBreadcrumbClicked('Entity'),
      },
      {
        label: `Published Work`,
        to: `/${entityName}`,
      },
      {
        label: reportName,
        to: `${links.publishedReportView({
          entityName,
          reportID,
          reportName,
        })}${window.location.search}`,
        onClick: () => trackBreadcrumbClicked('Report'),
      },
    ],
    [entityName, reportID, reportName]
  );

  return parts;
}

const NavBreadcrumbsPublishedReport: FC<
  NavBreadcrumbsPublishedReportProps
> = params => {
  const parts = useNavBreadcrumbsPublishedReportParts(params);
  return <Breadcrumbs parts={parts} />;
};

export default NavBreadcrumbsPublishedReport;
